import { PasswordService } from './../../../../services/identity/password';
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { TabPosition, TabStripComponent, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { FileInfo, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { firstValueFrom, Observable } from 'rxjs';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountSummary } from '~/models/administration/account';
import { PersonCustomer, PersonListing, PersonSummaryWithShopperLicense } from '~/models/administration/person';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { entityStatusOptions, EntityStatusOptions } from '~/models/entityStatus';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AppRolesService } from '~/services/administration.ts/approles';
import { UsersService } from '~/services/administration.ts/users';
import { IdentityUsersService } from '~/services/identity/user';
import { MobileAppGroupsService } from '~/services/modules/stocks/administration/mobile-app-groups';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { securityLevelMapOptions } from '../list/security-level-map';
import { NoteComponent } from '~/shared/components/note/note.component';
import { DepartmentDto } from '~/models/modules/department';
import { DepartmentsService } from '~/services/modules/assets/department';
import { FormatService } from '~/services/administration.ts/format';
import { AssignedAssetsPopupComponent } from '../assigned-assets-popup/assigned-assets-popup.component';
import { ResetPasswordPopupComponent } from '../reset-password-popup/reset-password-popup.component';
import { StocksDeactivatingDataComponent } from '~/shared/components/deactivate-data/deactivate-data';
import { formatDate } from '@angular/common';
import { FilesService } from '~/services/modules/stocks/files';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { fileSources } from '~/shared/enums/fileSources';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { GDataService } from '~/services/GDataService';
import { ActivatedRoute } from '@angular/router';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { ISiteListing } from '~/models/modules/Common/siteDto';
import { AccountSiteObject } from '~/models/administration/accountSiteObject';
import { AssetService } from '../../../../services/modules/assets/asset.service';
import { CustomersService } from '../../../../services/modules/stocks/customers';
import { GridLayoutComponent } from '../../../../shared/components/grid/layout/layout.component';
import { DropDownSettingsService } from '~/services/administration.ts/drop-down-settings';
import { SitesEnum } from '~/shared/enums/sites.enum';

@Component({
    selector: 'person-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StocksUsersUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy, AfterContentChecked, AfterViewInit {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];
  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _selectedAppRoles: any[] = [];
  _assetShoppingPermissions: any[] = [];
  _stockShoppingPermissions: any[] = [];
  _selectedAssetShoppingPermissions: any[] = [];
  _selectedStockShoppingPermissions: any[] = [];
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _theme: string;
  _datePickerFormat: string;
  _costFormat: string;
  _profilePic: any;
  _storagePath: string;
  // _isNew: boolean;
  _form: FormGroup;
  _userActivityForm: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _showImagesGrid: boolean;
  _timezones: any[];
  _timezonesFiltered: any[];
  _stockMobileAppGroups: any[];
  _stockMobileAppGroupsFiltered: any[];

  _invalidForm: boolean = false;
  _personCode = new FormControl();
  _email = new FormControl();
  isUser = new FormControl();
  _model: PersonSummaryWithShopperLicense = null;
  _pageState: PageState;
  _isOs: boolean;
  _addClassActive: boolean = false;
  _addUserInfoActive: boolean = false;
  _stockShopperActive: boolean = false;
  _assetShopperActive: boolean = false;

  _tooltipVisibilityUpsert: boolean = true;
  dropdownSettings: any;
  _tooltipVisibilityForm: boolean = true;
  _showCirclesForm: boolean;
  _page: string = 'persons';
  _permissionScope = 'persons';
  _index: number;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _deactivatedFieldsGridData: Array<any> = [];
  _deactivatedFieldsForm: boolean = false;
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _gridFieldText: GridFieldTextSummary[];
  _language: string = "en";
  _systemFields: Array<any> = [];
  _carriers: Array<string> = ["Alltel", "AT&T", "Boost Mobile", "Metrocall", "Metro PCS", "Nextel", "Sprint PCS", "T-Mobile", "Virgin Mobile", "Verizon"];
  _carriersFiltered: Array<string> = ["Alltel", "AT&T", "Boost Mobile", "Metrocall", "Metro PCS", "Nextel", "Sprint PCS", "T-Mobile", "Virgin Mobile", "Verizon"];
  _editedSystemFields: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  _orderingTabsForm: boolean = false;
  okCloseSubscription: any = null;
  _customFieldsValue: any = [];
  _customFields: CustomFieldSummary[][] = [];
  _customTabs: any;
  _selectedAccountIds: any[] = [];
  _selectedAccount = new FormControl();
  _loggedInSiteId: number;
  _invalidSubmit: boolean;
  _custominvalidForm: boolean;
  _selectedLabelId: number;
  _selectedTabId: number;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;
  _selectedLabelObjectCode: any;
  _isAddTabFormValue: boolean = false;
  _customFieldsDictionary: { [key: string]: string } = {};
  _deactivateConfirmed: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  _isDialiog: boolean = false;
  _isEditForms: boolean = false;
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.image];
  _customValidation: any = [];
  _customRequiredFields: Array<any> = [];

  @ViewChildren(GridLayoutComponent) childGrids!: QueryList<GridLayoutComponent<number>>;

  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: "DC Health"
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: "Safe Workplace"
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: "District Logistics Center"
    }
  ];

  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: "District Logistics Center"
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: "Safe Workplace"
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: "DC Health"
    }
  ];

  _hasAssignedAssets = false; // Should be implemented in Asset Module

  _dummyAssignedAssets = [
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "modelDescription": "Ipad",
      "location": "Location ABC",
      "status": "Active"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "modelDescription": "Ipad",
      "location": "Location ABC",
      "status": "Active"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "modelDescription": "Ipad",
      "location": "Location ABC",
      "status": "Active"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "modelDescription": "Ipad",
      "location": "Location ABC",
      "status": "Active"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "modelDescription": "Ipad",
      "location": "Location ABC",
      "status": "Active"
    }
  ];

  _dummyCheckedAssets = [
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "checkedDate": "01/06/2022 12:00PM",
      "dueDate": "12/06/2022 12:00PM",
      "status": "Past Due"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "checkedDate": "01/06/2022 12:00PM",
      "dueDate": "12/06/2022 12:00PM",
      "status": "Past Due"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "checkedDate": "01/06/2022 12:00PM",
      "dueDate": "12/06/2022 12:00PM",
      "status": "Past Due"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "checkedDate": "01/06/2022 12:00PM",
      "dueDate": "12/06/2022 12:00PM",
      "status": "Past Due"
    },
    {
      "assetId": 11234,
      "assetDescription": "Ipad",
      "checkedDate": "01/06/2022 12:00PM",
      "dueDate": "12/06/2022 12:00PM",
      "status": "Past Due"
    },
  ];

  _listOfLeadVars: Array<string> = [
    'hours',
    'days',
    'weeks',
    'months',
    'years',
  ];

  _activityDateRangeOptions: Array<string>;

  _imageTabActive: boolean = true;
  _showimageTab: boolean = true;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _statusFieldsCount: number = 0;

  persons: PersonListing[];
  selectedManagers: PersonListing[] = [];
  primaryManager: PersonListing;

  departments: DepartmentDto[] = [];
  selectedDepartments: DepartmentDto[] = [];
  primaryDepartment: DepartmentDto;

  customers: PersonCustomer[] = [];
  selectedCustomers: PersonCustomer[] = [];

  myFiles: Array<FileInfo> = [];

  _imageStream: any;

  reactivate: boolean = false;
  reactivateItem: any;

  _userStatus: Array<any>;
  _selectedUserStatus: any[] = [];
  _userActiviyLogs: any[];
  _file: File;
  profileImageFileId: string = '';
  profileImagePath: string = '';
  isAdmin: boolean;
  copyModelId: number;
  accessFrom: string;
  _isUserInfoEnabled: boolean = false;

  _isMultiSite: boolean = false;
  _isMultiSiteSelected: boolean = false;
  _siteList: ISiteListing[];
  _siteListSelected: ISiteListing[] = [];
  _userSites: AccountSiteObject[];
  _selectedUserSites: AccountSiteObject[];

  _popupSaveModel: any;

  @ViewChild('tabstrip') public tabstrip: TabStripComponent;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Person_ID') kendoBarcodeGenPersonID: ElementRef;
  @ViewChild('email_Input') emailInput: ElementRef;
  @ViewChild('Kendo_Combobox_Timezone') KendoComboboxTimezone: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Person_Carrier') KendoComboboxPersonCarrier: ComboBoxComponent;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('userInfo') userInfo: TabStripTabComponent;
  @ViewChild('employmentInfo') employmentInfo: TabStripTabComponent;
  @ViewChild('contactInfo') contactInfo: TabStripTabComponent;
  @ViewChild('kendo_Input_First_Name') kendoInputFirstName: ElementRef;
  @ViewChild('kendo_Input_Last_Name') kendoInputLastName: ElementRef;
  @ViewChild('kendo_uploader') upload: UploadComponent;
  @ViewChild('note') note: NoteComponent;
  @ViewChild('activityRange') activityRangeKendoCombobox: ComboBoxComponent;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;

  constructor(private _accountsService: AccountsService,
    private _appRolesService: AppRolesService,
    private _usersService: IdentityUsersService,
    private _userService: UsersService,
    private _departmentsService: DepartmentsService,
    private _fb: FormBuilder,
    private _formatService: FormatService,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _mobileAppGroupsService: MobileAppGroupsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    private _sharedService: SharedService,
    private _filesService: FilesService,
    private _dataService: GDataService,
    private _passwordService: PasswordService,
    private route: ActivatedRoute,
    private _sitesService: MultiSiteService,
    private _assetService: AssetService,
    private _customersService: CustomersService,
    private _dropDownSettingsService: DropDownSettingsService) {
    super();
    this._activityDateRangeOptions = [
      'Today (' + formatDate(Date.now(), this._formatService.dateFormat, 'en-US') + ')',
      'Last 7 days',
      'Last 28 days',
      'Last 3 months',
      'Last 6 months',
      'Last 12 months',
      'Custom'
    ];
  }

  ngAfterViewInit(): void {
    this.getSystemFieldsAndCustomFields();
  }

  isChecked(item: any) {
    if (this._selectedUserStatus.find((x) => x.id === item.id)) {
      return true;
    }

    return false;
  }

  userStatusChange(event: any) {
    if (this._form.controls['isUser'].value == false) {
      this._form.controls['twoFactorEnabled'].setValue(false);
      this._form.controls['hasComplexPassword'].setValue(false);
      this._form.controls['isMobileUser'].setValue(false);
    }

    if (!this._form.controls['isActive'].value && this._model.id) {
      this._deactivate();
    }
  };

  shoppingStatusChange(event: any) {
    let isShopping = this._form.controls['isShopping'].value;
    //let hasShoppingPermissions = this._selectedAssetShoppingPermissions?.length > 0 || this._selectedStockShoppingPermissions?.length > 0;

    if (!isShopping) {
      this._form.controls['isShopping'].setValue(false);
      this._selectedAssetShoppingPermissions = [];
      this._selectedStockShoppingPermissions = [];

      //this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      //  if (data) {
      //    this._form.controls['isShopping'].setValue(false);
      //    this._selectedAssetShoppingPermissions = [];
      //    this._selectedStockShoppingPermissions = [];
      //  }
      //  else {
      //    this._form.controls['isShopping'].setValue(true);
      //  }
      //});

      //this._layoutComponent.openPopup({
      //  title: 'Notification',
      //  message: "This will reset shopper settings. Are you sure?"
      //});
    }
    else {
      this._form.controls['isShopping'].setValue(true);
    }
  };

  openfromlist: any;

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    // var timezoneOffset = 120;
    // this._model.hireDate = new Date(this._model.hireDate);
    // this._model.hireDate.setTime(this._model.hireDate.getTime() - timezoneOffset * 60000);
    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }

    this.openfromlist = this._sharedService.model.openfromlist;

    if (!this._currentUser.isEnterprise)
      this._checkMultiSitesLicense();
  }
  /*
  check license
  if multi site
    yes >> check if All Sites Selected
      Yes >> Display site selection
      No >> Cancel operation
    No >> Cancel Operation
  */
  _checkMultiSitesLicense() {
    this._securityService.getLicense().subscribe((data: any) => {
      if (data.general.numberOfSites > 1) {
        this._isMultiSite = true;
      }

      if (this._isMultiSite == true) {
        var userSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));
        if (userSites && userSites.length > 0) {
          let selectedSite = userSites[0].siteId;

          if (selectedSite == null || selectedSite == SitesEnum.AllSites) {
            this._isMultiSiteSelected = true;
            this._getSiteList();
          }
          else {
            let site: any = { siteId: userSites[0].siteId }
            this._selectedUserSites = [];
            this._selectedUserSites.push(site);
            this.GetPersons();
          }
        }
      }
    });
  }

  _getSiteList() {
    this._sitesService.getAllSites().subscribe((data: ISiteListing[]) => {
      const allSitesObj: ISiteListing = {
        id: SitesEnum.AllSites,
        code: 'All Sites',
        name: 'All Sites',
        status: EntityStatusOptions.Active
      };

      const sites = data || [];
      const hasAllSites = sites.some(s => s.id === SitesEnum.AllSites || s.code === 'All Sites');
      this._siteList = hasAllSites ? sites : [allSitesObj, ...sites];

      this._userSites = this._siteList.map((d: ISiteListing) => { return <any>{ accountId: 1, site: d } });

      if (this._model && Object.keys(this._model).length > 0 && this._model.id && this._model.user?.userSites) {
        this._siteListSelected = this._model.user.userSites.map((f: AccountSiteObject) => {
          const isAllSites = !f.site || f.site?.id === SitesEnum.AllSites || f.siteId === SitesEnum.AllSites;
          const targetId = isAllSites ? SitesEnum.AllSites : (f.site?.id ?? SitesEnum.AllSites);
          const matchedSite = this._siteList.find(s => s.id === targetId);
          return matchedSite || <ISiteListing>{
            code: isAllSites ? 'All Sites' : (f.site?.code ?? 'All Sites'),
            id: targetId,
            userSiteId: f.id,
            name: isAllSites ? 'All Sites' : (f.site?.name ?? 'All Sites'),
            status: EntityStatusOptions.Active
          };
        });

        this._selectedUserSites = this._model.user.userSites.map((f: AccountSiteObject) => {
          const isAllSites = !f.site || f.site?.id === SitesEnum.AllSites || f.siteId === SitesEnum.AllSites;
          return <AccountSiteObject>{
            siteId: isAllSites ? SitesEnum.AllSites : (f.site?.id ?? SitesEnum.AllSites),
            accountId: 1,
            site: isAllSites ? allSitesObj : f.site,
            id: f.id ?? 0
          };
        });
      }
    });
  }

  SiteListChanged(e: any) {
    let selected: ISiteListing[] = e || [];

    const allSitesItem = (this._siteList || []).find(s => s.id === SitesEnum.AllSites) || <ISiteListing>{
      id: SitesEnum.AllSites,
      code: 'All Sites',
      name: 'All Sites',
      status: EntityStatusOptions.Active
    };

    const hasAllSitesNow = selected.some(s => s.id === SitesEnum.AllSites);
    const hadAllSitesBefore = (this._siteListSelected || []).some(s => s.id === SitesEnum.AllSites);

    if (this._siteList && this._siteList.length > 1 && selected.length === this._siteList.length) {
      selected = [allSitesItem];
    } else if (hasAllSitesNow && !hadAllSitesBefore) {
      selected = [allSitesItem];
    } else if (hasAllSitesNow && hadAllSitesBefore && selected.length > 1) {
      selected = selected.filter(s => s.id !== SitesEnum.AllSites);
    }

    this._siteListSelected = selected;
    this._selectedUserSites = this._siteListSelected.map((f: ISiteListing) => {
      return <any>{
        accountId: 1,
        id: f.userSiteId ?? 0,
        siteId: f.id
      };
    });

    this.GetPersons();
  }

  ngAfterContentChecked(): void {
    //this.cdRef.detectChanges();
  }

  _imageTabClick() {
    this._imageTabActive = true;
  }

  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }

  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }

  _edit() {
    this._pageState = PageState.EDIT;
    this.accountTab.selected = true;
    this.accountTab.disabled = false;
    this.userInfo.disabled = !(this._form.controls['isUser']?.value || this._form.controls['isShopping']?.value);
    this.employmentInfo.disabled = true;
    this.contactInfo.disabled = true;
  }

  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  }

  _getAppRoles = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var result = this._appRolesService.getAppRolesForUser(params, model);
    return result;
  }


  _getAssetPermissions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    //this._assetShoppingPermissions = [
    //  { id: 1, name: "Asset Shopper", description: "Request Checkout of Assets" },
    //  { id: 2, name: "Custody Requestor", description: "Request Custody of Assets" },
    //  { id: 3, name: "Maintenance Requestor", description: "Request Maintenance for Assets" },
    //  { id: 4, name: "Disposal Requestor", description: "Request Disposal of Assets" },
    //  { id: 5, name: "View Only", description: "View Only Assets on Asset Shop" }
    //];

    return this._assetService.getAssetPermissions(params, model);
  }

  _getStockPermissions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    //this._stockShoppingPermissions = [
    //  { id: 1, name: "Inventory Shopper", description: "Browse and Order available Inventory" },
    //  { id: 2, name: "Site Transfer", description: "Browse and Order Available Inventory for Site Transfer" },
    //  { id: 3, name: "View Only", description: "View Only available Inventory" }
    //];

    return this._assetService.getStockPermissions(params, model);
  }

  //#region  ngOnInit
  async ngOnInit() {
    this._viewInactiveFormTabs()
    this._currentUser = this._securityService.currentUser;

    this.route.data.subscribe((data: any) => { this.accessFrom = data.accessFrom; });

    try {
      this.dropdownSettings = await firstValueFrom(this._dropDownSettingsService.getDropDownSettings());
    } catch (error) {
      console.error('Error fetching drop down settings', error);
    }

    this._getdata();

    this._themeManager.themeChange.subscribe((data) => { this._theme = data; });

    this._layoutManager.applyOverly();

    this.initializeShoppingPermissions();
    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW || this._pageState == PageState.COPY) {
      if (this._pageState != PageState.COPY) {
        const userSites = this._model?.user?.userSites ?? [];
        this._selectedAccounts = userSites.map((item: any) => ({
          siteId: item?.site?.id ?? item?.siteId,
          accountId: item?.account?.id ?? item?.accountId,
          userId: item?.userId
        }));
        this._selectedAccountIds = this._selectedAccounts.map((a: any) => +a.accountId);
      }

      if (this._model.user && this._model.user.appRole) {
        this._selectedAppRoles.push(this._model.user.appRole.id);

        if (this._model.user.appRole.id == 99991) {
          this._selectedAppRoles = [];
          this._model.user.isUser = false;
          this._model.isUser = false;
        }
      }

      this._tabEnabled = this._selectedAccounts.length > 0;
    }

    //this._currentUser = this._securityService.currentUser;
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }

    this.isAdmin = this._currentUser.appRole.name === "Admin";

    if (this._selectedImagesKeys.length === 0) {
      this._showimageTab = false;
    }
    else {
      this._showimageTab = true;
    }

    this._initForm();

    this._securityService.getLicense().subscribe((data: any) => {
      if (data && data.general) {
        this._form.patchValue({
          haveShopperLicense: data.general.shoppingCart
        });
      }
    });

    await this.getFormTabs();
    this.loadLabels();


    let _entityName: string = 'stock';

    if (this.accessFrom == 'assets') {
      _entityName = 'asset';
    }

    this._customFieldsService.getDeactivatedCustomFields(_entityName, this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });

    this.getAuth();

    this.setStatusFieldsCount();

    if (this._sharedService?.model?.accessFrom) {
      this.accessFrom = this._sharedService?.model?.accessFrom;
    }

    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';

    if (this._pageState == PageState.EDIT) {
      this._getProfileImage();
    }

    this.GetPersons();

    this.GetDepartments();

    this._initActivityForm();
    // if(this.accessFrom == 'stocks'){
    this._form.patchValue({ isUser: true });
    this._isUserInfoEnabled = true;

    //}

    this._LoadTimezonesDD();
    this._LoadStockMobileAppGroupsDD();
    this._viewInactiveFields(true);

    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenPersonID?.nativeElement?.focus();
      }, 500);
    }
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.isAttachment == true) {
        if ((str?.response && str.component == 'files')) {
          this._addProfilePic(str);
          this._isDialiog = false;
        }
      }
    });
  }

  _profilePicList: any = [];

  _addProfilePic(fileData: any = null) {
    let profilePic: any = {};
    profilePic.fileid = fileData.response.id;
    //profilePic.filename = fileData.response.name;
    profilePic.file = fileData.picObject.file;
    //profilePic.stockItemId = this._model.id ? this._model.id : 0;
    //profilePic.status = EntityStatusOptions.Active;
    this._profilePic = { ...profilePic };
    this._profilePicList.push(this._profilePic);
  }

  _removePicHandler(event: any) {
    this._profilePic = undefined;
  }

  initializeShoppingPermissions() {
    if (this._model.isAssetShopper) {
      this._selectedAssetShoppingPermissions.push(1);
    }

    if (this._model.isCustodyRequestor) {
      this._selectedAssetShoppingPermissions.push(2);
    }

    if (this._model.isMaintenanceRequestor) {
      this._selectedAssetShoppingPermissions.push(3);
    }

    if (this._model.isDisposalRequestor) {
      this._selectedAssetShoppingPermissions.push(4);
    }

    if (this._model.isAssetShopperViewOnly) {
      this._selectedAssetShoppingPermissions.push(5);
    }

    if (this._model.isInventoryShopper) {
      this._selectedStockShoppingPermissions.push(1);
    }

    if (this._model.isSiteTransfer) {
      this._selectedStockShoppingPermissions.push(2);
    }

    if (this._model.isStockShopperViewOnly) {
      this._selectedStockShoppingPermissions.push(3);
    }
  }

  requiredSystemTabs: any = [];
  //#endregion
  // New Set Mandatory
  setMandatoryFields() {
    this._customValidation = [];
    //this.getSystemFields();
    //this.loadCustomFields(this._model?.id?.toString());
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    /* let execludeFields:string[] = [];
    execludeFields.push('email');
    execludeFields.push('timezone.name'); */
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText?.isRequired && item.page?.trimEnd('') == this._page) {
          if (item.field == "entityContact.email") {
            if (this._form.controls["isUser"].value == false)
              this._requiredFields.push(item);
          }
          else {
            this._requiredFields.push(item);
          }

        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired && item3.formTab?.page == this._page) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);

            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      let tabElementList = this.navTrigger?.nativeElement?.querySelector('ul');

      //if(Array.from(tabElementList?.children) != undefined){
      Array.from(tabElementList?.children)?.forEach((child: any) => {
        child.classList.remove('mendatoryTab');
      });

      Array.from(tabElementList?.children)?.forEach((child: any) => {
        if (child.firstChild.innerText == 'User Info') {
          child.classList.add('mendatoryTab');
        }

        if (child.firstChild.innerText == 'Contact Info' && !this._form.controls["isUser"].value) {
          child.classList.add('mendatoryTab');
        }

        if (this._requiredFieldNames.find((x) => x.name === child.firstChild.innerText
          && (x.page ? x.page.trimEnd('') == this._page : x.formTab.page.trimEnd('') == this._page))) {
          child.classList.add('mendatoryTab');
        }

        if (this.requiredSystemTabs.find((x: any) => x.name === child.firstChild.innerText)) {
          child.classList.add('mendatoryTab');
        }
      });

      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue = element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0 ?
            element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
      //}
    }, 500);
  }
  _barcodeSubmited() {
    this._personCode.setValue(this._form.get('code').value);

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputFirstName.nativeElement.focus();
        let FirstName = this.kendoInputFirstName;
        FirstName.nativeElement.classList.add('focusedInput');
        let LastName = this.kendoInputLastName;
        LastName.nativeElement.classList.remove('focusedInput');
      });
    }
  }

  _barcodeFocus() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenPersonID.nativeElement.focus();
        this._addClassActive = false;
        let FirstName = this.kendoInputFirstName;
        FirstName?.nativeElement.classList.remove('focusedInput');
        let LastName = this.kendoInputLastName;
        LastName?.nativeElement.classList.remove('focusedInput');
      });
    }
  }

  _firstNameSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputLastName.nativeElement.focus();
        this.kendoInputFirstName.nativeElement.blur();
        let FirstName = this.kendoInputFirstName;
        FirstName.nativeElement.classList.remove('focusedInput');
        let LastName = this.kendoInputLastName;
        LastName.nativeElement.classList.add('focusedInput');
      });
    }
  }

  _firstNameFocus() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputFirstName.nativeElement.focus();
        this._addClassActive = false;
        let FirstName = this.kendoInputFirstName;
        FirstName.nativeElement.classList.add('focusedInput');
        let LastName = this.kendoInputLastName;
        LastName.nativeElement.classList.remove('focusedInput');
      });
    }
  }

  _skipFirstName() {
    this.kendoInputFirstName.nativeElement.blur();
    this.kendoInputLastName.nativeElement.focus();
    let FirstName = this.kendoInputFirstName;
    FirstName.nativeElement.classList.remove('focusedInput');
    let LastName = this.kendoInputLastName;
    LastName.nativeElement.classList.add('focusedInput');
  }

  _lastNameSubmited() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._addClassActive = true;
        this.kendoInputLastName.nativeElement.blur();
        let LastName = this.kendoInputLastName;
        LastName.nativeElement.classList.remove('focusedInput');
      });
    }
  }

  _lastNameFocus() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this._addClassActive = false;
        let LastName = this.kendoInputLastName;
        LastName.nativeElement.classList.add('focusedInput');
        let FirstName = this.kendoInputFirstName;
        FirstName.nativeElement.classList.remove('focusedInput');
      });
    }
  }

  _skipLastName() {
    this.kendoInputLastName.nativeElement.blur();
    this._addClassActive = true;
    let LastName = this.kendoInputLastName;
    LastName.nativeElement.classList.remove('focusedInput');
  }

  _emailSubmited() {
    this._email.setValue(this._form.get('userName').value);

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.KendoComboboxTimezone.toggle(true);
        this.KendoComboboxTimezone.focus();
      });
    }
    // this._initForm();
  }

  //#region  GetPersons
  personSetting: string;

  async GetPersons() {
    let siteIds: any = [];

    if (this._selectedUserSites) {
      this._selectedUserSites.forEach(element => {
        siteIds.push(element.siteId);
      });
    }

    (await this._userService.getPersonsBySiteIds(siteIds)).subscribe((data: any) => {
      var persons = data;
      persons.forEach((element: any) => { element.title = element.code; });

      this.persons = persons;

      const displayAsName = this.dropdownSettings?.manager === 'displayName';
      if (displayAsName) {
        this.persons.forEach((p: any) => {
          if (!p.firstName) {
            p.firstName = '';
          }

          if (!p.lastName) {
            p.lastName = '';
          }

          var fullnamevar = '';

          if (p.firstName || p.lastName) {
            fullnamevar = (p.firstName + ' ' + p.lastName).trim();
          }
          else {
            fullnamevar = p.code;
          }

          p.fullName = fullnamevar;
        });

        this.personSetting = 'fullName';
      }
      else {
        this.personSetting = 'code';
      }

      if (this._model && this._model.managers && this._model.managers.length > 0) {
        this.selectedManagers = this.persons.filter(f => this._model.managers.map(x => x.managerId).indexOf(f.id) > -1);
        this.primaryManager = this.persons.find(f => this._model.managers.find(x => x.isPrimary)?.managerId == f.id);
      }
    });
  }
  //#endregion

  //#region GetDepartments
  depatmentSetting: string;

  async GetDepartments() {
    (await this._departmentsService.getDepartments()).subscribe((departments: any) => {
      departments.forEach((element: any) => {
        element.title = element.code;
      });

      this.departments = departments;

      const displayAsName = this.dropdownSettings?.department === 'displayName';
      if (displayAsName) {
        this.departments.forEach((p: any) => {
          let fullnamevar = p.name ? p.name : ''
          p.fullName = (fullnamevar == '' || fullnamevar == undefined) ? p.code : fullnamevar;
        });

        this.depatmentSetting = 'fullName';
      }
      else {
        this.depatmentSetting = 'code';
      }

      if (this._model && this._model.personDepartments && this._model.personDepartments.length > 0) {
        this.selectedDepartments = this.departments.filter(f => this._model.personDepartments.map(x => x.departmentId).indexOf(f.id) > -1);
        this.primaryDepartment = this.departments.find(f => this._model.personDepartments.find(x => x.isPrimary)?.departmentId == f.id);
      }
    });
  }
  //#endregion

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  ProfilePictureFile: Array<FileInfo> = [];

  _fileSelectedChanges(ev: SelectEvent) {
    // ev.isDefaultPrevented = true;
    this.ProfilePictureFile = [];

    if (ev)
      //this.PictureCopyEvent.push(ev.files);
      ev.files.forEach((file: FileInfo) => {
        if (file.rawFile) {
          var isValid = this.checkFileExtention(file.rawFile);

          if (!isValid) {
            this.myFiles = [];
            this._imageStream = null;

            return;
          }
          else {
            this.ProfilePictureFile.push(file);
            this._file = file.rawFile;
            const reader = new FileReader();
            reader.readAsDataURL(file.rawFile);
            reader.onloadend = () => {
              this._imageStream = reader.result;
              let imgElement = "<img src=" + this._imageStream + "/>";

              document.getElementsByClassName("k-file-group-wrapper ")[0].innerHTML = "";
              var element = document.createElement('img');
              element.src = this._imageStream;
              element.style.position = "relative";
              element.style.verticalAlign = "top";
              element.style.height = "50px";
              document.getElementsByClassName("k-file-group-wrapper ")[0].replaceWith(element);
            };
          }
        }
      });
  }

  checkFileExtention(file: any) {
    let isValid = false;
    let fileUploadedName = file.name;
    const allowedExtensions = ['png', 'jpeg', 'jpg'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1].toLowerCase();

    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Only PNG, JPG, JPEG extensions are allowed.',
        withoutConfirm: true
      });

      isValid = false;
    }
    else {
      isValid = true;
    }

    return isValid;
  }

  _fileRemoveEventHandler() {
    this._imageStream = null;
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }

  private runGenerateBarcode() {
    let counter = 1;

    this.generateBarcode(counter).subscribe((data: any) => {
      this._personCode.setValue(data.result.toString());
      this._form.patchValue({ code: data.result.toString() });

      setTimeout(() => {
        this.kendoInputFirstName.nativeElement.focus();
        let FirstName = this.kendoInputFirstName;
        FirstName.nativeElement.classList.remove('focusedInput');
        let LastName = this.kendoInputLastName;
        LastName.nativeElement.classList.remove('focusedInput');
      });
    });
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('persons', quantity);
  }

  _getSecurityLevel(securityLevel: string) {
    return securityLevelMapOptions[securityLevel];
  }

  _LoadTimezonesDD() {
    return this._accountsService.getTimezones().subscribe((data: any) => {
      this._timezones = data;
      this._timezonesFiltered = this._timezones;
    });
  }

  _handleTimezoneFilter(value: any) {
    this._timezonesFiltered = this._timezones.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleCarriersFilter(value: any) {
    this._carriersFiltered = this._carriers.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _onManagerChange(event: any) {
    this.selectedManagers = event;
  }

  _onPrimaryManagerChange(event: any) {
    this.primaryManager = event;
  }

  _onDepartmentChange(event: any) {
    this.selectedDepartments = event;
  }

  _onPrimaryDepartmentChange(event: any) {
    this.primaryDepartment = event;
  }

  _onCustomerChange(event: any) {
    this.selectedCustomers = event;

    //const unique = [...new Set(this.selectedCustomers.map(item => item))];

    const arrayUniqueByKey = [...new Map(this.selectedCustomers.map(item => [item["id"], item])).values()];

    this.selectedCustomers = arrayUniqueByKey;
  }

  _LoadStockMobileAppGroupsDD() {
    return this._mobileAppGroupsService.getMobileAppGroupListing().subscribe((data: any) => {
      this._stockMobileAppGroups = data;
      this._stockMobileAppGroupsFiltered = this._stockMobileAppGroups;
    });
  }

  _handleStockMobileAppGroupFilter(value: any) {
    this._stockMobileAppGroupsFiltered = this._stockMobileAppGroups.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;

    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;

    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    }
    else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }

    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onTabSelect(tabSelected: any) {
    this._mobileMenuToggle();

    if (tabSelected.title == 'User Info') {
      // this._fileSelectedChanges(event, true)
      if (this.ProfilePictureFile.length > 0) {
        setTimeout(() => {
          document.getElementsByClassName("k-file-group-wrapper ")[0].innerHTML = "";
          var element = document.createElement('img');
          element.src = this._imageStream;
          element.style.position = "relative";
          element.style.verticalAlign = "top";
          element.style.height = "50px";
          document.getElementsByClassName("k-file-group-wrapper ")[0].replaceWith(element);
        }, 500);
      }

      this._addUserInfoActive = true;
    }

    if (tabSelected.title == "Activity Logs") {
      this._getLatestActivityLogs();
    }

    if (tabSelected.title == "Stock Shopper") {
      this._stockShopperActive = true;
      this.GetCustomers();
    }

    if (tabSelected.title == "Asset Shopper") {
      this._assetShopperActive = true;
    }
  }

  GetCustomers() {
    this._customersService.getCustomersListing().subscribe((cutomers: any) => {
      this.customers = cutomers;

      if (this._model && this._model.personCustomers && this._model.personCustomers.length > 0) {
        this.selectedCustomers = this.customers.filter(cust => this._model.personCustomers.map(x => x.customerId).indexOf(cust.id) > -1);
      }
    });
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  isValidEmail(email: string): boolean {
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  _onSave(e: any) {
    if (!this._currentUser.isEnterprise && this._isMultiSite == true && this._isMultiSiteSelected == true
      && (this._siteListSelected.length == 0 || this._siteListSelected == undefined)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select at least one site',
        withoutConfirm: true
      });
    }
    else {
      /* this._selectedAccounts = this._siteListSelected.map((f) => {
        return{
          id:f.id ?? 0,
          siteId: f.id,
          accountId: 1
        }
      }); */

      if (this._isMultiSiteSelected == true) {
        this._selectedAccounts = this._selectedUserSites.map((f) => {
          return {
            id: f.id ?? 0,
            siteId: f.siteId != null ? f.siteId : SitesEnum.AllSites,
            accountId: 1
          }
        });
      }
      else {
        let accountSiteData = localStorage.getItem('loggedInAccountSites');

        if (accountSiteData) {
          let JsonData = JSON.parse(accountSiteData);
          JsonData.forEach((s: { siteId: number, accountId: number }) => {
            if (!this._selectedAccounts.find(x => x.siteId == s.siteId)) {
              this._selectedAccounts.push({ siteId: s.siteId, accountId: s.accountId });
            }
          });
        }
      }

      this.submit(e);
    }
  }

  _onEditForm() { }

  _onCancel() {
    this._closeForm(this._popupSaveModel);
  }

  _closeForm(response: any = null) {
    var closeComponent = {
      response: this.openfromlist ? null : response,
      component: this._page,
      isClosed: true
    }

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects(this._page);
    // this._layoutManager.setFromChanged('users');
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }

  _onAppRoleRowSelectionChanges(selectedItems: any[]) {
    this._selectedAppRoles = [];

    selectedItems.forEach((item) => {
      this._selectedAppRoles.push(+item);
    });

    if (this._selectedAppRoles.length != 0) {
      if (this._pageState == PageState.ADD) {
        setTimeout(() => {
          //this.emailInput.nativeElement.focus();
          this._addUserInfoActive = false;
        });
      }
    }
  }

  _onAssetShoppingSelectionChanges(selectedItems: any[]) {
    this._selectedAssetShoppingPermissions = [];

    if (selectedItems.includes(5) && !this._selectedAssetShoppingPermissions.includes(5)) {
      const child = this.childGrids.toArray().find(c => c.id === "assetShoppingPermissionsGrid");

      if (child) {
        child.ClearSelectedKeys(5);
      }
      else {
      }

      selectedItems = [];
      selectedItems.push(5);
    }

    selectedItems.forEach((item) => {
      this._selectedAssetShoppingPermissions.push(+item);
    });
  }

  _onStockShoppingSelectionChanges(selectedItems: any[]) {
    this._selectedStockShoppingPermissions = [];

    if (selectedItems.includes(3) && !this._selectedStockShoppingPermissions.includes(3)) {
      const child = this.childGrids.toArray().find(c => c.id === "stockShoppingPermissionsGrid");

      if (child) {
        child.ClearSelectedKeys(3);
      }
      else {
      }

      selectedItems = [];
      selectedItems.push(3);
    }

    selectedItems.forEach((item) => {
      this._selectedStockShoppingPermissions.push(+item);
    });
  }

  private _initForm() {
    this._form = this._fb.group({
      code: [(this._model) && (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) ? this._model.code : null, Validators.required],
      firstName: [this._model ? this._model.firstName : '', this.getLabel('LBL_PersonFirstName')?.isRequired ? Validators.required : null],
      lastName: [this._model ? this._model.lastName : '', this.getLabel('LBL_PersonLastName')?.isRequired ? Validators.required : null],
      //Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
      userName: [this._model && this._model.user ? this._model.user.email : this._model.entityContact ? this._model.entityContact.email : ''],//, [Validators.required, Validators.email]],
      email: [this._model && this._model.user ? this._model.user.email : this._model.entityContact ? this._model.entityContact.email : ''],
      isActive: [this._model && this._model.user ? this._model.user.status == 'active' : true],
      isUser: [this._model && this._model.isUser ? true : false],
      isShopping: [this._model ? this._model.isShopping : false],
      isInventoryShopper: [this._model ? this._model.isInventoryShopper : false],
      isSiteTransfer: [this._model ? this._model.isSiteTransfer : false],
      isStockShopperViewOnly: [this._model ? this._model.isStockShopperViewOnly : false],
      isAssetShopper: [this._model ? this._model.isAssetShopper : false],
      isCustodyRequestor: [this._model ? this._model.isCustodyRequestor : false],
      isMaintenanceRequestor: [this._model ? this._model.isMaintenanceRequestor : false],
      isDisposalRequestor: [this._model ? this._model.isDisposalRequestor : false],
      isAssetShopperViewOnly: [this._model ? this._model.isAssetShopperViewOnly : false],

      haveShopperLicense: [false],

      customerIds: [this._model && this._model.personCustomers ? this._model.personCustomers.map(cust => cust.customerId) : []],

      profileImage: [(this._model) && (this._pageState == PageState.EDIT) ? this._model.profile : null],
      twoFactorEnabled: [this._model && this._model.user?.twoFactorEnabled, this.getLabel('LBL_PersonTwoFactorLogin')?.isRequired ? Validators.required : null],
      addressLine1: [this._model && this._model.entityContact ? this._model.entityContact.addressLine1 : null, this.getLabel('LBL_PersonAddressLine1')?.isRequired ? Validators.required : null],
      addressLine2: [this._model && this._model.entityContact ? this._model.entityContact.addressLine2 : null, this.getLabel('LBL_PersonAddressLine2')?.isRequired ? Validators.required : null],
      addressCity: [this._model && this._model.entityContact ? this._model.entityContact.city : null, this.getLabel('LBL_PersonCity')?.isRequired ? Validators.required : null],
      addressState: [this._model && this._model.entityContact ? this._model.entityContact.state : null, this.getLabel('LBL_PersonState')?.isRequired ? Validators.required : null],
      addressZip: [this._model && this._model.entityContact ? this._model.entityContact.zip : null, this.getLabel('LBL_PersonZip')?.isRequired ? Validators.required : null],
      addressCountry: [this._model && this._model.entityContact ? this._model.entityContact.country : null, this.getLabel('LBL_PersonCountry')?.isRequired ? Validators.required : null],
      contactPerson: [this._model && this._model.entityContact ? this._model.entityContact.person : null, this.getLabel('')?.isRequired ? Validators.required : null],
      contactPhone1: [this._model && this._model.entityContact ? this._model.entityContact.phone1 : null, this.getLabel('LBL_PersonPhone1')?.isRequired ? Validators.required : null],
      contactPhone2: [this._model && this._model.entityContact ? this._model.entityContact.phone2 : null, this.getLabel('LBL_PersonPhone2')?.isRequired ? Validators.required : null],
      contactFax: [this._model && this._model.entityContact ? this._model.entityContact.fax : null, this.getLabel('')?.isRequired ? Validators.required : null],
      contactEmail: [this._model && this._model.entityContact ? this._model.entityContact.email : null, this.getLabel('LBL_PersonContactEmail')?.isRequired ? [Validators.required, Validators.email] : null],
      contactSms: [this._model && this._model.entityContact ? this._model.entityContact.smsAddress : null, this.getLabel('LBL_PersonSmsAddress')?.isRequired ? Validators.required : null],
      contactCarrier: [this._model && this._model.entityContact ? this._model.entityContact.carrier : null, this.getLabel('LBL_PersonCarrier')?.isRequired ? Validators.required : null],
      timezone: [this._model && this._model.user && this._model.user.timezone ? this._model.user.timezone : null],//, Validators.required],
      hasComplexPassword: [this._model && this._model.user?.hasComplexPassword, this.getLabel('LBL_PersonHasComplexPassword')?.isRequired ? Validators.required : null],
      isMobileUser: [this._model && this._model.user?.isMobileUser, this.getLabel('LBL_PersonMobileUser')?.isRequired ? Validators.required : null],
      title: [(this._model) ? this._model.title : null, this.getLabel('LBL_PersonTitle')?.isRequired ? Validators.required : null],
      hireDate: [(this._model && this._model.hireDate) ? new Date(this._model.hireDate) : null, this.getLabel('LBL_PersonHireDate')?.isRequired ? Validators.required : null],
      leaveDate: [(this._model && this._model.leaveDate) ? new Date(this._model.leaveDate) : null, this.getLabel('LBL_PersonLeaveDate')?.isRequired ? Validators.required : null],
      stockMobileAppGroup: [this._model && this._model.user && this._model.user.mobileAppGroup ? this._model.user.mobileAppGroup : null]
    });

    this._form.controls.isUser.valueChanges.subscribe(val => {
      if (val == true) {
        this._isUserInfoEnabled = true;
        this._form.controls.userName.setValidators([Validators.required, Validators.email]);
        this._form.controls.userName.setErrors(['required']);
        this._form.controls.userName.updateValueAndValidity();
        this._form.controls.timezone.setValidators([Validators.required]);
        this._form.controls.timezone.setErrors(['required']);
        this._form.controls.timezone.updateValueAndValidity();
        this._form.controls.contactEmail.clearValidators();
        this._form.controls.contactEmail.setErrors(null);
        this._form.controls.contactEmail.updateValueAndValidity();
      }
      else {
        this._isUserInfoEnabled = false;
        this._form.controls.userName.clearValidators();
        this._form.controls.userName.setErrors(null);
        this._form.controls.timezone.clearValidators();
        this._form.controls.timezone.setErrors(null);
        this._form.controls.contactEmail.setValidators(
          this.getLabel('LBL_PersonContactEmail')?.isRequired ? [Validators.required, Validators.email] : null
        );
        this._form.controls.contactEmail.updateValueAndValidity();
      }
      this.setMandatoryFields();
    });


    if (this._form.controls['isUser'].value) {
      this._form.patchValue({ isUser: true });

      this._isUserInfoEnabled = true;
      this._form.controls.userName.setValidators([Validators.required, Validators.email]);
      this._form.controls.userName.setErrors(['required']);
      this._form.controls.userName.updateValueAndValidity();
      this._form.controls.timezone.setValidators([Validators.required]);
      this._form.controls.timezone.setErrors(['required']);
      this._form.controls.timezone.updateValueAndValidity();
    }

    if (this._pageState == PageState.COPY) {
      this._pageState = PageState.ADD;
      this._model.user.email = null;
      this._model.code = null;
      // this._model.personCustomers = [];
      this._model.id = null;
    }

    if (!this._currentUser.isEnterprise) {
      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";

      if (loggedInAccountSites != "") {
        var accountId = JSON.parse(loggedInAccountSites)[0].accountId;
        this._selectedAccount.setValue({ id: accountId });
      }
    }

    this.setUserStatuses();
  }

  private clearuserlocatstorge(data: any) {
    if (data.twoFactorEnabled === true) {
      if (localStorage.getItem('enterprise_user_accounts')) {
        let accounts: string[] = JSON.parse(localStorage.getItem('enterprise_user_accounts'));
        let pushtostoragelist = accounts.filter((a: any) => a !== data.email);

        if (this._model.isUser == true) {
          if (this._model.user.userName === accounts.find((a: any) => a === data.email)) {
            localStorage.removeItem('enterprise_user_accounts');
            pushtostoragelist.forEach((s: any) => { accounts.push(s); });

            localStorage.setItem('enterprise_user_accounts', JSON.stringify(pushtostoragelist));
          }
        }
      }
    }
  }

  private _initActivityForm() {
    this._userActivityForm = new FormGroup({
      from: new FormControl(null, [Validators.required]),
      to: new FormControl(null, [Validators.required]),
      activityRangeItem: new FormControl(null)
    });
  }

  _additionalErrors: any = [];

  private submit = (e: string) => {
    var sitesSelected: boolean = true;

    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });

        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter((x: any) => x.siteId != -1);

        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });

          sitesSelected = false;

          return false;
        }
      }
    }

    if (this._form.get('isUser').value && this._selectedAppRoles.length === 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please choose a security level.',
        withoutConfirm: true
      });

      if (this.accessFrom == "stocks") {
        this.tabstrip.selectTab(0);
      }
      else {
        this.tabstrip.selectTab(1);
      }
    }
    else if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    else {
      // work with custom fields
      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      const model = this._form.value;

      if (this._pageState == PageState.ADD) {
        model.profileImage = null;
      }

      this._invalidForm = false;

      model['profile'] = model.profileImage;
      model['customFieldsValue'] = this._customFieldsDictionary;

      ////////////////////////
      model['managerIds'] = this.selectedManagers.map(x => x.id);
      model['departmentIds'] = this.selectedDepartments.map(x => x.id);

      model['customerIds'] = this.selectedCustomers.map(x => x.id);

      model['primaryManagerId'] = this.primaryManager?.id;
      model['primaryDepartmentId'] = this.primaryDepartment?.id;
      model['isUser'] = model.isUser ? true : false;
      model['userId'] = this._model ? this._model.userId : null;
      model['entityContactId'] = this._model && this._model.entityContact ? this._model.entityContact.id : null;

      this.setShoppingModel(model);

      if (model.isUser == true) {
        model['user'] = {
          firstName: model.firstName,
          lastName: model.lastName,
          userName: model['isUser'] == true ? model.userName : model.contactEmail,
          email: model['isUser'] == true ? model.userName : model.contactEmail,
          timezoneId: model.timezone?.id,
          userSites: this._selectedAccounts,
          appRoleId: this._selectedAppRoles[0],
          twoFactorEnabled: model.twoFactorEnabled ? true : false,
          hasComplexPassword: model.hasComplexPassword ? true : false,
          isMobileUser: model.isMobileUser ? true : false,
        };
      }
      else {  /* if(this._isMultiSite && this._isMultiSiteSelected == true) */
        model['user'] = {
          userName: model.contactEmail,
          email: model.contactEmail,
          userSites: this._selectedAccounts,
          timezoneId: model.timezone?.id,
          appRoleId: this._selectedAppRoles[0]
        }
      }

      model['entityContact'] = {
        addressLine1: model.addressLine1,
        addressLine2: model.addressLine2,
        city: model.addressCity,
        state: model.addressState,
        zip: model.addressZip,
        country: model.addressCountry,
        phone1: model.contactPhone1,
        phone2: model.contactPhone2,
        email: model['isUser'] == true ? model.userName : model.contactEmail,
        smsAddress: model.contactSms,
        carrier: model.contactCarrier
      }

      if (this._pageState == PageState.EDIT) {
        model['entityContact'].id = this._model && this._model.entityContact ? this._model.entityContact.id : null;
      }

      if (model.isUser == true) {
        this.clearuserlocatstorge(model);
      }

      if (!model.isUser && model.isShopping) {
        model.isUser = true;

        model['user'] = {
          id: (this._pageState == PageState.EDIT && this._model && this._model.user) ? this._model.user.id : null,
          firstName: model.firstName,
          lastName: model.lastName,
          userName: model.contactEmail,
          email: model.contactEmail,
          timezoneId: 16,  // -300:Eastern Standard Time
          appRoleId: 99991,  // NotUserShopper
          userSites: this._selectedAccounts,
          twoFactorEnabled: false,
          hasComplexPassword: false,
          isMobileUser: false,
        };
      }

      //Quraim
      let profileImageModel: any = {};

      if (this._imageStream) {
        profileImageModel.stream = this._imageStream;
        profileImageModel.size = this._file.size;
        profileImageModel.type = this._file.type;
        profileImageModel.fileSourceId = fileSources.users;
        profileImageModel.typesToChecks = this._allowedFileTypes;
        profileImageModel.exension = this._file.name.substring(this._file.name.lastIndexOf(".") + 1).toLowerCase();
        profileImageModel.name = model.code;// this._file.name ? this._file.name.substring(0, this._file.name.lastIndexOf('.')) : '';
        profileImageModel['accountIds'] = this._selectedAccount.value ? [this._selectedAccount.value.id] : [];

        this._uploadProfileImage(profileImageModel, e, model);
      }
      else {
        this._doSubmit(e, model);
      }
    }
  }
  //#endregion

  setShoppingModel(model: any) {
    model['isShopping'] = this._form.controls['isShopping'].value;

    if (this._selectedAssetShoppingPermissions.indexOf(1) > -1) {
      model['isAssetShopper'] = true;
    }
    else {
      model['isAssetShopper'] = false;
    }

    if (this._selectedAssetShoppingPermissions.indexOf(2) > -1) {
      model['isCustodyRequestor'] = true;
    }
    else {
      model['isCustodyRequestor'] = false;
    }

    if (this._selectedAssetShoppingPermissions.indexOf(3) > -1) {
      model['isMaintenanceRequestor'] = true;
    }
    else {
      model['isMaintenanceRequestor'] = false;
    }

    if (this._selectedAssetShoppingPermissions.indexOf(4) > -1) {
      model['isDisposalRequestor'] = true;
    }
    else {
      model['isDisposalRequestor'] = false;
    }

    if (this._selectedAssetShoppingPermissions.indexOf(5) > -1) {
      model['isAssetShopperViewOnly'] = true;
    }
    else {
      model['isAssetShopperViewOnly'] = false;
    }
    ///////////////////////

    if (this._selectedStockShoppingPermissions.indexOf(1) > -1) {
      model['isInventoryShopper'] = true;
    }
    else {
      model['isInventoryShopper'] = false;
    }

    if (this._selectedStockShoppingPermissions.indexOf(2) > -1) {
      model['isSiteTransfer'] = true;
    }
    else {
      model['isSiteTransfer'] = false;
    }

    if (this._selectedStockShoppingPermissions.indexOf(3) > -1) {
      model['isStockShopperViewOnly'] = true;
    }
    else {
      model['isStockShopperViewOnly'] = false;
    }
  }

  _doSubmit(e: string, model: any) {
    if (model.isMobileUser) {
      model.mobileAppGroupId = model.stockMobileAppGroup?.id;
    }
    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      let modelId = this._model.id;

      this._usersService.updateUser(this._model.id, model).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this._userService.personUpdated.emit(response.dataId); // Person Id
          this._layoutComponent.openPopup({
            title: 'Alert',
            //message: 'User updated Successfully',
            message: response["message"],
            withoutConfirm: true
          });

          if (response["close"] != null) {
            if (response["close"] == true) {
              // this._closeForm();
              if (e === "saveAndClose") {
                this._closeForm(model);
              }
              else if (e === "saveAndCopy") {
                this.copyModelId = this._model.id;
                this._model.id = undefined;
                this._model.code = undefined;

                this._form.controls.code.setValue(null);
                this._form.controls.profileImage.setValue(null);
                this._form.controls.userName.setValue(null);
                this._form.controls.contactEmail.setValue(null);
                this._pageState = PageState.ADD;
                this._selectedAccounts = [];
                this._imageStream = undefined;
                this._profilePic = undefined;
                this.loadCustomFields();
                this.profileImagePath = '';
                this._popupSaveModel = { ...model };
              }
              else if (e === "saveAndNew") {
                this._openForm(this._page);
                //this.openUpsert(this._page, {}, PageState.ADD);
                //this._closeForm();
              }
              else if (e === 'save') {
                this._model = { ...model };
                this._model.id = modelId;
                this._popupSaveModel = { ...model };
              }
            }
            else {
              return;
            }
          }
        }
      });
    }
    else {
      this._usersService.createUser(model).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          let isUserModel = this._form.controls.isUser.value ?? false;

          if (!this._currentUser.isEnterprise) {
            //this.note.createNoteForUser(isUserModel ? response.extraData : response.dataId);
            this.note.createNoteForUser(response.dataId);
          }

          this._userService.personAdded.emit(response.dataId); // Person Id
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response["message"],//'User added Successful',
            withoutConfirm: true
          });

          if (response["close"] != null) {
            let responseData: any = {};
            responseData = isUserModel ? response.extraData1 : response.extraData;

            if (response["close"] == true) {
              // this._closeForm();
              if (e === "saveAndClose") {
                this._closeForm(responseData);
              }
              else if (e === "saveAndCopy") {
                this.copyModelId = this._model.id;
                this._model.id = undefined;
                this._model.code = undefined;
                this._form.controls.code.setValue(null);
                this._form.controls.profileImage.setValue(null);
                this._form.controls.userName.setValue(null);
                this._form.controls.contactEmail.setValue(null);
                this._selectedAccounts = [];
                this._imageStream = undefined;
                this._form.value.profileImage = undefined;
                this.profileImagePath = '';
                this._popupSaveModel = { ...responseData };
                this.loadCustomFields();
              }
              else if (e === "saveAndNew") {
                this._openForm(this._page);
                //this.openUpsert(this._page, {}, PageState.ADD);
                //this._closeForm();
              }
              else if (e === 'save') {
                this._pageState = PageState.EDIT;
                //this._model.id = isUserModel ? response.extraData : response.dataId;

                this._model = response.extraData;
                this._model.id = response.dataId;
                this._popupSaveModel = { ...responseData };
              }
            }
            else {
              return;
            }
          }
        }

        //this._closeForm();
      });
    }
  }

  async _uploadProfileImage(imageModel: any, e: string, model: any) {
    if (this._pageState == PageState.ADD) {
      this._doUploadImage(imageModel, e, model, true);
    }
    else if (this._pageState == PageState.EDIT) {
      let imageId = model["profile"];

      if (imageId != null && imageId != '') {
        this._doUploadImage(imageModel, e, model, false, imageId);
      }
      else {
        this._doUploadImage(imageModel, e, model, true);
      }
    }
  }

  _doUploadImage(imageModel: any, e: string, model: any, isNew: boolean = true, imageId: number = 0) {
    if (isNew == true) {
      this._filesService.createFile(imageModel).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this.profileImageFileId = response["responseId"];
          model["profile"] = this.profileImageFileId;
          this.profileImagePath = imageModel.stream;
          this._doSubmit(e, model);
        }
      });
    }
    else {
      this._filesService.updateFile(imageId, imageModel).subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this.profileImagePath = imageModel.stream;
          this._doSubmit(e, model);
        }
      });
    }
  }

  _getProfileImage() {
    this.profileImagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + this._model?.profileImage?.stream;
    return this.profileImagePath;// EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/'+this._model.person?.profileImage?.stream;
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
      else {
        this._editFormActive = true;
        this._isCustomfieldsFormValue = true;
      }
    }
  }

  _viewInactiveFields(onLoad: boolean = false) {
    this._customFieldsService.getDeactivatedCustomFields('stock').subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    });

    // if (!onLoad) {
    //   this._deactivatedFieldsForm = true;
    // }
  }

  _returnAdNew() {
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
    this._pageState = PageState.ADD;
  }

  async getFormTabs() {
    let _function = this._gridFields.getformTabsByPage(this._page);
    let tabsNames = await firstValueFrom(_function);

    this._dataTabs = tabsNames;
    this._dataTabsSelected = tabsNames;
    this._userNewDataTabs = tabsNames;
    //});
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      }
      else {
        result = null
      }

      return result ? result : null;
    }
  }

  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      this._initForm();
    });
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    })
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
      this.loadCustomFields(this._model?.id?.toString());
    });
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element))
    });

    this._systemFields.find(x => x.id === oldLocData.id).formOrder = sysFClone.find(x => x.id === newLocData.id).formOrder;
    this._systemFields.find(x => x.id === newLocData.id).formOrder = sysFClone.find(x => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization[]) => {
      this._gridFieldAuth = x;
      this.setStatusFieldsCount();
    });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null

      return result ? result : new GridFieldAuthorization();
    }
  }

  isCurrentUser() {
    return this._currentUser.id == this._model.userId;
  }

  // createformtabmapper( getformtab: any)
  // {

  // }
  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      })
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }


  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item).subscribe((response: any) => {
          if (response != null && response["message"] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response["message"],
              withoutConfirm: true
            });

            if (response["close"] != null) {
              if (response["close"] == true) {
                //this.loadCustomFields(this._model?.id?.toString());
                this.getSystemFieldsAndCustomFields();
                this.getFormTabs();
                this._viewInactiveFields(true);
                // this._deactivatedFieldsForm = false;
              }
              else {
                return;
              }
            }
          }

          // this._deactivatedFieldsForm = false;
        });

        // this._deactivatedFieldsForm = false;
      }
      else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  private loadCustomFields(entityId?: string) {

    this._customFields = [];
    //this._pacer.start();
    let _entityName: string = 'Stock';
    // if(this.accessFrom == 'assets'){
    //   _entityName = 'asset';
    // }
    this._customFieldsService.getCustomFields(_entityName, this._page).subscribe((data) => {
      if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
        let that = this;

        data.map(function (x) { x.entityId = that._model.id ?? that.copyModelId; });
      }

      var tabIds = data.map((item) => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
      let that = this;

      tabIds.forEach(function (formTabId) { that._customFields[formTabId] = grouped.get(formTabId); });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};

        grouped.forEach(element => {
          element.forEach((value: any) => {
            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }
          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);
        });
      }

      this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
        this.setMandatoryFields();
      });
    });
  }

  // New
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };

      let item = null;

      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });

      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);

        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }

      var requiredCustomerField = this._customValidation.find((x: any) => x.name == key);

      if (requiredCustomerField) {
        let item2 = null;

        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });

        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);

          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }

      this._additionalErrors = [];

      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);

          this.setMandatoryFields();
          this._viewInactiveFields(true);

          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }

  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }

  _addNewField(tabId: number) {
    this._selectedLabelId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }

  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == "persons" ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     if (response != null && response["message"] != null) {
  //         //get custom tabs first
  //         this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
  //       });

  //       this._layoutComponent.openPopup({
  //         title: 'Alert',
  //         message: response["message"],
  //         withoutConfirm: true
  //       });

  //       if (response["close"] != null) {
  //         if (response["close"] == true) {
  //           // this._closeForm();
  //           this.getFormTabs();
  //         }
  //         else {
  //           return;
  //         }
  //       }
  //     }
  //     //   this._closeForm();
  //   });
  // }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
  }

  _closeCustomFields() {
    if (this._isAddTabFormValue) {
      this.getFormTabs();
    }

    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.loadLabels();

    this.getAuth();
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  setStatusFieldsCount() {
    this._statusFieldsCount = 0;
    if (this.getAuthByLabel('LBL_Active')?.canView) this._statusFieldsCount++;
    if (this.getAuthByLabel('LBL_TwoFactorLogin')?.canView) this._statusFieldsCount++;
    if (this.getAuthByLabel('LBL_ComplexPassword')?.canView) this._statusFieldsCount++;
    if (this.getAuthByLabel('LBL_MobileUser')?.canView) this._statusFieldsCount++;
    if (this.getAuthByLabel('LBL_IsUser')?.canView) this._statusFieldsCount++;
  }

  setUserStatuses() {
    this._userStatus = [
      { id: 'active', title: this.getLabel("LBL_Active")?.currentText },
      { id: 'twoFactorLogin', title: this.getLabel("LBL_TwoFactorLogin")?.currentText },
      { id: 'complexPassword', title: this.getLabel("LBL_ComplexPassword")?.currentText },
      { id: 'mobileUser', title: this.getLabel("LBL_MobileUser")?.currentText },
    ];
  }

  deactivate: boolean = false;

  _deactivate() {
    this.deactivate = true;
    this._hasAssignedAssets = false; // Should be checked in Assets// Temp Set To False For Stock

    if (this._hasAssignedAssets && !this._currentUser.isEnterprise) {
      this._sharedService.okCloseClicked.subscribe((data: boolean) => {
        if (data && !this._deactivateConfirmed) {
          this._layoutComponent.openDialogForm(AssignedAssetsPopupComponent, null, { itemId: this._model.id, pageName: this._page });
          this._deactivateConfirmed = true;
        }
      });

      this._deactivateConfirmed = false;

      this._layoutComponent.openPopup({
        title: 'Notification',
        message: 'This user has assets assigned to them. <br/> Would you like to proceed with the deactivation?'
      });
    }
    else {
      this._sharedService.okCloseClicked.subscribe((data: boolean) => {
        if (data && this.deactivate) {
          this.deactivate = false;
          this._layoutComponent.openDialogForm(StocksDeactivatingDataComponent, PageState.VIEW, { itemId: this._model.id, pageName: this._page });
        }
        else {
          this.deactivate = false;
        }

        this._onCancel();
      });

      this._layoutComponent.openPopup({
        title: 'Notification',
        message: 'Are you sure you want to deactivate the user ' + this._model.entityContact.email + '?' + '<br/>' + 'If yes, the user ' + this._model.entityContact.email +
          ' will be moved to deactivated data.'
      });
    }
  }

  _closeActivityRange() {
    this.activityRangeKendoCombobox.toggle(false);
    this.activityRangeKendoCombobox.value = null;
    this._userActivityForm.controls["activityRangeItem"].setValue(null);
  }

  _onActivityRangeClose(event: any) {
    event.preventDefault();
  }

  _activityRangeChange(value: any) {
    this._userActivityForm.controls["activityRangeItem"].setValue(value);
  }

  _getLatestActivityLogs() {
    this._userService.getUserLatestActivityLogs(this._model.userId, 10).subscribe((result: any) => {
      this._userActiviyLogs = result;
    });
  }

  _getActivityLogsByRange() {
    if (this._userActivityForm.controls["activityRangeItem"].value) {
      let from = new Date();
      let to = new Date();

      switch (this._userActivityForm.controls["activityRangeItem"].value) {
        case 'Last 7 days':
          from.setDate(from.getDate() - 7);
          break;
        case 'Last 28 days':
          from.setDate(from.getDate() - 28);
          break;
        case 'Last 3 months':
          from.setDate(from.getDate() - 91);
          break;
        case 'Last 6 months':
          from.setDate(from.getDate() - 182);
          break;
        case 'Last 12 months':
          from.setDate(from.getDate() - 365);
          break;
        case 'Custom':
          if (this._userActivityForm.valid) {
            from = this._userActivityForm.controls["from"].value;
            to = this._userActivityForm.controls["to"].value;
          }
          break;
        default:
          from.setHours(0, 0, 0, 0);
          break;
      }

      this._userService.getUserActivityLogsByRange({
        id: this._model.id,
        from: from,
        to: to
      }).subscribe((result: any) => {
        this._userActiviyLogs = result;
        this.activityRangeKendoCombobox.toggle(false);
      });
    }
  }

  _openForm(componentName: string, AddPicture: boolean = false) {
    if (!AddPicture) {
      this._pageState = PageState.ADD;
    }

    const model = { isNew: true, showUp: true };

    this._sharedService.model = model;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: model, pageState: PageState.ADD, isDocumnet: true, reload: 'model', fileSource: fileSources.users };
    this._isDialiog = true;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  _closeDialog(event: any) {
    if (event?.response && event.component == 'mobileAppGroups') {
      this._form.controls['stockMobileAppGroup'].setValue(event.response);
      this._LoadStockMobileAppGroupsDD();
      this._isDialiog = event.open;
    }
    else {
      this._isDialiog = event;
    }
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  resetPassword() {
    let email = this._form.value.email;

    if (email) {
      const model = { email: email };

      this._sharedService.okCloseClicked.subscribe((data: boolean) => {
        if (data) {
          this._passwordService.resetFromUserForm(model).subscribe(() => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: 'An email has been sent to ' + email,
              withoutConfirm: true
            });
            // this._finishMessage = 'An email has been sent to ' + this._email.value;

            // this._confirmationStep = false;
            // this._emailSentStep = true;
          },
            (error: any) => {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: 'Invalid email.',
                withoutConfirm: true
              });
              // this.error = 'Invalid email.';
            });
        }
      });

      this._layoutComponent.openPopup({
        title: 'Notification',
        message: 'A password reset email will be sent to ' + email
      });
    }
  }

  resetPasswordPopup() {
    let email = this._model.user?.email;
    let hasComplexPassword = this._model.user?.hasComplexPassword;

    this._layoutComponent.openDialogForm(ResetPasswordPopupComponent, null, { email: email, hasComplexPassword: hasComplexPassword, pageName: this._page });
  }
}
